import { url } from "../../../../varEntorn/Url.link";

export const DownloadReport = ({metadata}) => {

  let empresa_ = ''
  if(metadata.tuser === 'megaUser')empresa_ = null
  else empresa_ = metadata.empresa

  return new Promise(async function(resolve, reject) {
    try {
      const query = await fetch(url+'/fugatorio/createreportfile',{
        method: 'POST',
        headers: {
          'authorization': "marcuxo",
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          empresa: empresa_
        })
      })

        const reqkkst = await query.json();
        // console.log(reqkkst)
        if(reqkkst.success){
          resolve(reqkkst.body)
        }else{
          resolve(null)
        }
      } catch (error) {
        resolve(null)
      }
    

  })
}
